import { useSearch } from "@tanstack/react-router";
import * as React from "react";
import styled from "styled-components";
import { ContentRow } from "@/styles/stylings";
import { LANGUAGE_NAMES, LANGUAGES } from "@/types";
import { activeLanguages } from "@/urlState";

const H3 = styled.h3`
    margin-bottom: 0.5rem;
`;

function LangHeading() {
    const search = useSearch({ from: "/$version" });
    const langs = activeLanguages(search);
    return (
        <ContentRow>
            {LANGUAGES.filter((lang) => langs.includes(lang)).map((lang) => (
                <H3 key={lang}>{LANGUAGE_NAMES[lang]}</H3>
            ))}
        </ContentRow>
    );
}

export default React.memo(LangHeading);
